<template>
  <div>
    <h4 class="mt-3">
      {{ $t("PERFORMED_QUALITY_CONTROL") }}
    </h4>

    <v-row class="t-head">
      <v-col>{{ $t("DATE_AND_TIME") }}</v-col>
      <v-col>{{ $t("MANAGER") }}</v-col>
      <v-col
        >{{ $t("EXTERNAL_VIEW_COLOR") }}<br />
        {{ $t("OVERALL_PACKAGING") }}</v-col
      >
      <v-col>
        {{ $t("PRODUCT_CONFORMITY_WITH") }}<br />
        {{ $t("INSTRUCTIONS_FOR_REPACKAGING") }}
      </v-col>
      <v-col
        >{{ $t("CLARITY_AND_VERACITY_OF") }}<br />
        {{ $t("BATCH_NUMBER_AND_EXPIRATION_DATE") }}</v-col
      >
    </v-row>
    <template v-for="control in routemap.controls">
      <v-row class="row border-bottom" v-bind:key="'c' + control.id">
        <v-col class="t-row">{{ control.date }} {{ control.time }}</v-col>
        <v-col class="t-row">{{ control.user }}</v-col>
        <v-col class="t-row">{{
          control.package == true ? $t("MEETS") : $t("DOES_NOT_MEETS")
        }}</v-col>
        <v-col class="t-row">{{
          control.instructions == true ? $t("MEETS") : $t("DOES_NOT_MEETS")
        }}</v-col>
        <v-col class="t-row"
          >{{ control.batch == true ? $t("MEETS") : $t("DOES_NOT_MEETS") }}
        </v-col>
      </v-row>
    </template>
    <hr />
  </div>
</template>

<script>
export default {
  props: {
    routemap: {
      required: true,
      type: Object
    }
  }
};
</script>

<style scoped></style>
